import { Component, OnInit, ChangeDetectorRef, ViewChild, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ClmapComponent } from 'src/app/shared/components';
import { MAPDIST } from 'src/app/shared/config';

@Component({
  selector: 'app-14_sjjndsbzxx',
  templateUrl: './14_sjjndsbzxx.component.html',
  styleUrls: ['./14_sjjndsbzxx.component.styl']
})
export class LifeSjjndsbzxxComponent implements OnInit {
  ttitle = '';
  rows: any = [];
  showexpl = false;

  dcode = 0;
  dcodename = '';

  kw = '';
  title = '';
  resrows: any[] = [];

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private http: HttpClient,
    private cd: ChangeDetectorRef, ) { }

  @ViewChild('clmpref', { static: false }) public clmpref: ClmapComponent;

  ngOnInit() {
    this.ttitle = MAPDIST.sjjndsbzxx.title;
    this.http.get(MAPDIST.sjjndsbzxx.api).toPromise().then((rows: any) => {
      this.rows = rows;
      this.clmpref.refreshMapPanel();
    });

  }

  switchDist(obj: {id: number, name: string}) {
    this.dcode = obj.id;
    this.dcodename = obj.name;

    const totalRow = [];
    let title = '';
    for (let i = 0; i < this.rows.length; i++) {
      const row = this.rows[i];
      if (row.dcode === this.dcode) {
        title = row.district;
        totalRow.push(row);
      }
    }
    this.resrows = totalRow;
    this.title = this.dcodename;
    if (this.kw.length > 0) { this.kw = ''; }

    this.cd.detectChanges();
  }

  changeKw() {
    this.kw = this.kw.trim();
    if (this.kw.length === 0) {
      this.clmpref.refreshMapPanel(this.dcode);
      return;
    } else {
      this.clmpref.removeSelectMapPanel();
    }

    const totalRow = [];
    const p = new RegExp(this.kw, 'i');
    for (let i = 0; i < this.rows.length; i++) {
      const row = this.rows[i];

      let pjonoff = false;
      for (let ik = 0; ik < row.projects.length; ik++) {
        const pjname = row.projects[ik];
        if (p.test(pjname)) {
          pjonoff = true;
          continue;
        }
      }
      if (pjonoff || p.test(row.address) || p.test(row.name) || p.test(row.district)) {
        totalRow.push(row);
      }
    }

    this.resrows = totalRow;
    this.title = '检索';
  }


  closeKeyboard(i: number) {
    document.getElementById('xinput-' + i).blur();
    this.changeKw();
  }

  toView(i: number = -1) {
    this.ngZone.run(() => this.router.navigateByUrl('/pmap/sjjndsbzxx/' + i));
  }

}
